import { $, on } from "@olmokit/dom";
import { hasGtm } from "@olmokit/core/analytics";
import AuthFormLogin from "@olmokit/core/auth/form-login";
import { removeUrlQueryParams } from "@olmokit/utils/removeUrlQueryParams";
import { globalData } from "@olmokit/core/data";
import "@olmokit/core/forms/input/filled";
import "@olmokit/core/forms/checkbox";
import "./Login.scss";

/**
 * Component: AuthLogin
 */

export function AuthLogin($root?: HTMLElement) {
  $root = $root ? $root : $(".AuthLogin:");
  const $error = $(".error", $root);

  // const $password = $('.AuthLogin:recovery');
  // const $formpassword = $('.form-password');
  // const $formlogin = $('.form-login');
  // on($password, 'click', () => {
  //   $formpassword.style.display = 'block';
  //   $formlogin.style.display = 'none';
  // });

  AuthFormLogin($root, {
    succeded: (formData, instance, response) => {
      $error.innerHTML = response?.data?.msg || "";
      const route = globalData.route;
      const url = window.location.href;
      console.log('response', response);
      debugger;
      if(route == 'login'){
        const newparams = removeUrlQueryParams(url, ['auth-dialog']);
        window.history.replaceState({}, "", `${newparams}`);
        location.href = response.data.redirect;
      } else if(route == 'cart') {
        location.href = response.data.redirect;
      } else {
        const newparams = removeUrlQueryParams(url, ['auth-dialog']);
        window.history.replaceState({}, "", `${newparams}`);
        location.reload();
      }

      // const {
      //   id,
      //   password,
      //   token,
      //   token_active,
      //   end_session,
      //   ...userTrackData
      // } = response.data.user;

      // if (hasGtm()) {
      //   dataLayer.push({
      //     ...userTrackData,
      //     userId: id,
      //     event: "form sended",
      //     form: "Login",
      //     eventCallback: function () {
      //       location.href = response.data.redirect;
      //     },
      //     eventTimeout: 2000,
      //   });
      // } else {
      //   removeUrlParam('dialog-login');
      //   location.href = response.data.redirect;
      // }
    },
    failed: (formData, instance, response) => {
      console.log('$error', $error);
      $error.innerHTML = response?.data?.msg;
      // setTimeout(() => {
      //   $error.innerHTML = "";
      // }, 3000);
    },
  }); 
}